import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, Tabs, Tab, ButtonGroup, Button } from "react-bootstrap";
import { httpPost } from "../../utility/requestHelper";
import { envConfig } from "../../constants/api-endpoint";
import { NoFeedIcon, PrintIcon, GlobeIcon } from "../Icons/icons.component";
import {
  TABS,
  TABS_MAPPING,
  COOKIE,
  APP_CONSTANTS,
  MEDIA_TYPES,
  CONSTANTS,
  MAX_FEEDS_LIMIT,
  DATE_FORMATS,
} from "../../constants/app-constant";
import ShareArticle from "../Shared/ShareArticle";
import { REQUEST_CANCELLING_CONSTANTS } from "../../constants/cancel-request-constants";
import {
  getStartDateTime,
  getEndDateTime,
  formatDateTime,
  groupBy,
  formatDate,
  orderByCityList,
  formatArticleIdentifier,
} from "../../utility/common-methods";
import { getCookie } from "../../utility/cookieProvider";
import { AllFeedsModal } from "./AllFeedsModal";
import FeedItem from "./FeedItem";
import Loader from "../Shared/Loader";
import "./style.sass";
import { fetchPrintFeedsByEntity } from "../../actions/print-feeds-action";
import moment from "moment";

const cilClientList = [
  "CIL",
  "Pralhad Joshi",
  "Central Coalfields Ltd",
  "Eastern Coalfields Ltd",
  "Western Coalfields Ltd",
  "Northern Coalfields Ltd",
  "South Eastern Coalfields Ltd",
  "Mahanadi Coalfields Ltd",
  "Central Mine Planning and Design Institute",
  "Singareni Collieries Company Ltd",
  "Bharat Coking Coal Ltd",
];
const DashboardFeeds = () => {
  const PRINT = "print";
  const ONLINE = "online";
  const pressRelease = "Press Release";
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID) || null;
  const [apiInProgress, setApiInProgress] = useState(false);
  const [tabKey, setTabKey] = useState(TABS[0]);
  const [topic, setTopic] = useState(selectedClient.is_online_access.toString() === "1" && selectedClient.is_print_access.toString() === "0"?ONLINE:(selectedClient.is_print_access.toString() === "1"?PRINT:""));
  const [showModal, setShowModal] = useState(false);
  const [tabsSegregatedPrintData, setTabsSegregatedPrintData] = useState([]);
  const [PrintData, setPrintData] = useState([]);
  const [onlineTabData, setOnlineTabData] = useState([]);
  const [feedsToShare, setFeedsToshare] = useState([]);
  const [pressReleaseData, setPressReleaseData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { PRESS_RELEASE_FEEDS_API, PRINT_ONLINE_FEEDS_API } =
    REQUEST_CANCELLING_CONSTANTS;

  const selectedEntity =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.selectedEntity
    ) || null;

  const entityList =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.entityDetails &&
        state.entityAndKeyWordsReducer.entityDetails.entityList
    ) || CONSTANTS.EMPTY_ARRAY;
  // const clientName = selectedClient.client_name === "CIL";
  const clientName =
    cilClientList.indexOf(selectedClient.client_name) === -1 ? false : true;
  useEffect(() => {
    setApiInProgress(true);
    if (
      selectedClient &&
      selectedClient.id &&
      selectedEntity &&
      selectedEntity.id
    ) {
      getTodaysFeeds(topic, TABS[0], "all");
      getPressReleaseFeeds(topic, pressRelease);
    }
  }, [
    selectedClient && selectedClient.id,
    selectedEntity && selectedEntity.id,
    entityList,
  ]);
  // useEffect(() => {
  //   setApiInProgress(true);
  //   getTodaysFeeds(topic);
  //   getPressReleaseFeeds(topic, pressRelease);
  // }, [entityList]);

  function compare(a, b) {
    const key = "publish_datetime";
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  }

  const formatData = (data) => {
    try {
      let allArticleIdentifier = [];
      let newTopicData = [];
      let printData = [];
      let onlineData = [];
      let TotalPrintData = [];
      Object.keys(data).forEach((topic) => {
        const topicData = data[topic];
        const { Print = [], Online = [] } = topicData;
        newTopicData = topicData;
        const groupedPrintData = {};
        Print.forEach((d, i) => {
          const { headline, publication_id, publish_date } = d;
          const str = `${headline
            .toString()
            .trim()
            .toLowerCase()}_${publication_id}_${formatDate(
              publish_date,
              DATE_FORMATS.DDMMYYYY_dash
            )}`;
          groupedPrintData[str] = groupedPrintData[str]
            ? [...groupedPrintData[str], d]
            : [d];
          // console.log(groupedPrintData);
          // console.log([...groupedPrintData[str], d]);
          TotalPrintData.push(d);
        });
        Online.forEach((d) => {
          onlineData.push(d);
        });
        let newGrpdPrintData = {};
        Object.keys(groupedPrintData).forEach((pData) => {
          let currentData = groupedPrintData[pData];
          if (groupedPrintData[pData].length > 1) {
            const entities = groupedPrintData[pData].map(
              ({ abbreviation }) => abbreviation
            );
            const printGroupedData = {
              ...groupedPrintData[pData][0],
              abbreviation: entities,
            };
            printData.push(printGroupedData);
          } else {
            printData.push(groupedPrintData[pData][0]);
          }

          currentData = orderByCityList(currentData);
          const currentDataIdentifiers = formatArticleIdentifier(
            currentData[0]
          );
          allArticleIdentifier.push(currentDataIdentifiers);
          newGrpdPrintData[pData] = currentData;
        });
        newTopicData = {
          TotalPrintArticles: TotalPrintData,
          TotalOnlineArticles: Online.length,
          printData,
          onlineData,
        };
        const onlineArticleIdentifier = Online.map((e) =>
          formatArticleIdentifier(e)
        );
        allArticleIdentifier = [
          ...allArticleIdentifier,
          ...onlineArticleIdentifier,
        ];
        // newData[topic] = newTopicData;
      });
      return { formattedData: newTopicData, allArticleIdentifier };
    } catch (e) {
      return {
        formattedData: {},
        allArticleIdentifier: [],
      };
    }
  };

  const handleSelectedFeeds = (
    selected,
    {
      article_id,
      edition,
      entity_id,
      entity_name,
      entity_type,
      headline,
      language,
      publication,
      publication_type,
      publish_date,
      source,
      summary,
      source_name,
      link,
      photo,
      page_nos,
      imagebaseurl,
      images,
      article_type,
    }
  ) => {
    if (selected) {
      setFeedsToshare([
        ...feedsToShare,
        {
          article_id,
          edition,
          entity_id,
          entity_name,
          entity_type,
          headline,
          language,
          publication,
          publication_type,
          publish_date,
          source,
          summary,
          source_name,
          link,
          photo,
          page_nos,
          imagebaseurl,
          images,
          article_type,
        },
      ]);
    } else {
      setFeedsToshare(feedsToShare.filter((n) => n.article_id != article_id));
    }
  };

  const renderPrintTabData = () => {
    if (Object.keys(tabsSegregatedPrintData).length > 0) {
      return TABS.map((item, index) => {
        return (
          <Tab
            key={index}
            eventKey={item}
            title={`${item === "Competitor" && clientName ? "Subsidiaries" : item
              }(${PrintData && PrintData[item] ? PrintData[item].length : "0"})`}
          >
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                {tabsSegregatedPrintData[tabKey] ? (
                  tabsSegregatedPrintData[tabKey]
                    .map((item, idx) => {
                      return (
                        <FeedItem
                          tabKey={tabKey}
                          key={idx}
                          {...item}
                          checked={checkIfSelected(item.article_id)}
                          isModal={false}
                          topicType={topic}
                          onFeedSelect={handleSelectedFeeds}
                          articleIdList={tabsSegregatedPrintData[tabKey].map(
                            ({
                              article_id,
                              client_id,
                              entity_id,
                              Forclient_id,
                            }) =>
                              `${MEDIA_TYPES.PRINT_MV}/${client_id || Forclient_id
                              }-${article_id}-${entity_id}`
                          )}
                          abbreviation={item.abbreviation}
                        />
                      );
                    })
                    .slice(0, 2)
                ) : (
                  <div className="noFilterDataWrap no-feeds">
                    <NoFeedIcon size="sm" />
                    <h6>No Feeds Found</h6>
                  </div>
                )}
              </>
            )}
          </Tab>
        );
      });
    }
  };

  const renderOnlineTabData = () => {
    if (Object.keys(onlineTabData).length > 0) {
      return TABS.map((item, index) => {
        return (
          <Tab
            key={index}
            eventKey={item}
            title={`${item === "Competitor" && clientName ? "Subsidiaries" : item
              }(${onlineTabData && onlineTabData[item]
                ? onlineTabData[item].length
                : "0"
              })`}
          >
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                {onlineTabData[tabKey] ? (
                  onlineTabData[tabKey]
                    .map((item, idx) => (
                      <FeedItem
                        tabKey={tabKey}
                        key={idx}
                        {...item}
                        checked={checkIfSelected(item.article_id)}
                        showEntity={false}
                        topicType={topic}
                        onFeedSelect={handleSelectedFeeds}
                        articleIdList={onlineTabData[tabKey].map(
                          ({
                            article_id,
                            client_id,
                            entity_id,
                            Forclient_id,
                          }) =>
                            `${MEDIA_TYPES.ONLINE_MV}/${client_id || Forclient_id
                            }-${article_id}-${entity_id}`
                        )}
                      />
                    ))
                    .slice(0, 2)
                ) : (
                  <div className="noFilterDataWrap no-feeds">
                    <NoFeedIcon size="sm" />
                    <h6>No Feeds Found</h6>
                  </div>
                )}
              </>
            )}
          </Tab>
        );
      });
    }
  };

  const renderPressReleaseTab = () => {
    return (
      <Tab
        eventKey={pressRelease}
        title={`${pressRelease}(${pressReleaseData && pressReleaseData.length
            ? pressReleaseData.length
            : 0
          })`}
      >
        {pressReleaseData.length ? (
          pressReleaseData
            .map((item, idx) => (
              <FeedItem
                tabKey={tabKey}
                key={idx}
                {...item}
                showEntity={false}
                checked={checkIfSelected(item.article_id)}
                topicType={topic}
                onFeedSelect={handleSelectedFeeds}
                articleIdList={pressReleaseData.map(
                  ({ article_id, client_id, entity_id, Forclient_id }) =>
                    `${client_id || Forclient_id}-${article_id}-${entity_id}`
                )}
              />
            ))
            .slice(0, 2)
        ) : (
          <div className="noFilterDataWrap no-feeds">
            <NoFeedIcon size="sm" />
            <h6>No Feeds Found</h6>
          </div>
        )}
      </Tab>
    );
  };

  const getPressReleaseFeeds = (verticalType, type) => {
    setLoader(true);
    httpPost(
      `${getAPIUrls(verticalType, type)}`,
      {
        client_id:
          selectedClient && selectedClient.id
            ? selectedClient.id.toString()
            : "",
        entity_id: selectedEntity.id,
        entity_type: "client",
        limit: "1000",
        offset: "0",
        start_date: formatDateTime(getStartDateTime()),
        end_date: formatDateTime(getEndDateTime()),
        user_id: concept_uid,
      },
      {},
      true,
      PRESS_RELEASE_FEEDS_API
    )
      .then((response) => {
        setLoader(false);
        const { data } = response.data.result;
        setPressReleaseData(data || []);
      })
      .catch((e) => {
        if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
          setLoader(true);
          setPressReleaseData([]);
        } else {
          setLoader(false);
          setPressReleaseData([]);
        }
      });
  };

  const getAPIUrls = (verticalType, type, url = "") => {
    const {
      PRINT_ARTICLES_LIST,
      PRINT_PRESS_RELEASE_LIST,
      ONLINE_ARTICLES_LIST,
      ONLINE_PRESS_RELEASE_LIST,
    } = envConfig;

    if (verticalType === PRINT) {
      if (type !== pressRelease) {
        url = PRINT_ARTICLES_LIST;
      } else {
        url = PRINT_PRESS_RELEASE_LIST;
      }
    } else if (verticalType == ONLINE) {
      if (type !== pressRelease) {
        url = ONLINE_ARTICLES_LIST;
      } else {
        url = ONLINE_PRESS_RELEASE_LIST;
      }
    }
    return url;
  };

  const getTodaysFeeds = (verticalType, type = "Client", entityType = "") => {
    setTabsSegregatedPrintData([]);
    setOnlineTabData([]);
    setApiInProgress(true);
    let startdate = formatDateTime(getStartDateTime());
    let enddate = moment().format("YYYY-MM-DD");
    if(selectedClient.id == '11717'){
      let todaystartdate = moment(startdate).subtract(1, "day");
      todaystartdate = todaystartdate.format("YYYY-MM-DD");
      startdate = todaystartdate;
      //console.log("XXXXtodaystartdate:",todaystartdate);
    }    
    fetchPrintFeedsByEntity({
      timeout: 0,
      client_id: selectedClient.id,
      entity:
        entityList && entityList.length ? entityList.map(({ id }) => id) : [],
      range: {
        start: startdate,
        end: enddate,
      },
      publication_type: null,
      publication_id: [],
      edition_ids: null,
      zone: "",
      tonality: null,
      headline: null,
      keywords: null,
      client: null,
      category: null,
      vertical: 0,
      source_type: null,
      reporter: "",
      press_release: null,
      offset: 0,
      limit: MAX_FEEDS_LIMIT,
      favourite: null,
    })
      .then((res) => {
        setApiInProgress(false);
        const formattedList = formatData(res);
        const printData = formattedList.formattedData["printData"];
        const onlineData = formattedList.formattedData["onlineData"];
        const printDataTotal =
          formattedList.formattedData["TotalPrintArticles"];
        const filteredPrintData =
          printData.length > 0
            ? groupBy(printData.sort(compare), "entity_type")
            : [];
        const filteredOnlineData =
          onlineData.length > 0
            ? groupBy(onlineData.sort(compare), "entity_type")
            : [];
        setTabsSegregatedPrintData(filteredPrintData);
        setOnlineTabData(filteredOnlineData);
        const filteredTotalPrintData =
          printDataTotal.length > 0
            ? groupBy(printDataTotal.sort(compare), "entity_type")
            : [];
        setPrintData(filteredTotalPrintData);
      })
      .catch((e) => {
        if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
          setApiInProgress(true);
          setTabsSegregatedPrintData([]);
          setOnlineTabData([]);
        } else {
          setApiInProgress(false);
          setTabsSegregatedPrintData([]);
          setOnlineTabData([]);
        }
      });
  };

  const renderViewAll = () => {
    if (
      (tabsSegregatedPrintData &&
        tabsSegregatedPrintData[tabKey] &&
        tabsSegregatedPrintData[tabKey].length > 2) ||
      (onlineTabData &&
        onlineTabData[tabKey] &&
        onlineTabData[tabKey].length > 2) ||
      (pressReleaseData && pressReleaseData.length)
    ) {
      return (
        <div className="view-all-button" onClick={() => setShowModal(true)}>
          View All
        </div>
      );
    }
  };

  const setTopicName = (topic) => {
    setTopic(topic);
  };

  const handleTopicClick = (topic) => {
    setTopicName(topic);
    setTabKey(TABS[0]);
    // getTodaysFeeds(topic, TABS[0], "all");k
    // getPressReleaseFeeds(topic, pressRelease);
  };

  const handleTabClick = (tab) => {
    setTabKey(tab);
  };

  const checkIfSelected = (key) => {
    return feedsToShare.filter((f) => f.article_id == key).length;
  };
  return (
    <>
    {selectedClient.is_online_access == "1" || selectedClient.is_print_access == "1"?
      <Card className="cardWrap cls-tf" body>
        <div className="cardTop">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => handleTopicClick(e.target.value)}
          >
             {selectedClient.is_print_access == "1"?
              <Button
                className={topic === PRINT ? "tagOrange active" : "tagOrange"}
                value={"print"}
              >
                <PrintIcon />
                Print
              </Button>
              :""}
            {selectedClient.is_online_access == "1"?
              <Button
                className={topic === ONLINE ? "tagGreen active" : "tagGreen"}
                value={"online"}
              >
                <GlobeIcon />
                Online
              </Button>
            :""}
          </ButtonGroup>
          <ShareArticle
            client_id={selectedClient.id}
            article={feedsToShare}
            onShareSuccess={() => {
              setFeedsToshare([]);
            }}
            topicType={topic}
          />
        </div>
        {
          <>
            {apiInProgress || loader ? (
              <Loader />
            ) : (
              <>
                <Tabs
                  activeKey={tabKey}
                  transition={false}
                  onSelect={(k) => handleTabClick(k)}
                >
                  {topic == PRINT
                    ? renderPrintTabData()
                    : renderOnlineTabData()}
                  {renderPressReleaseTab()}
                </Tabs>
                {renderViewAll()}
              </>
            )}
          </>
        }
      </Card>
      :""}

      {showModal ? (
        <AllFeedsModal
          show={showModal}
          printData={tabsSegregatedPrintData}
          onlineData={onlineTabData}
          selectedTopic={topic}
          selectedTabKey={tabKey}
          onCancel={setShowModal}
          loaderState={apiInProgress}
          handleTabClick={handleTabClick}
          handleTopicClick={handleTopicClick}
          pressReleaseData={pressReleaseData}
          clientId={selectedClient.id}
          compare={compare}
          TotalPrintData={PrintData}
          clientName={clientName}
        />
      ) : null}
    </>
  );
};

export default DashboardFeeds;